module.exports = new __parcel__URL__("open-hihat_2.2f935a0f.mp3").toString();